import Layout from "@/layout";
import SignIn from "@/views/Sign";
import userQuery from '@/views/userQuery';
import personalManage from '@/views/personal-manage/personal-manage';
import cmsColumn from '@/views/cmsColumn';
import Column from '@/views/cms/Column';
import AddColumn from '@/views/cms/AddColumn';
import detailEdit from '@/views/personal-manage/detailEdit';
import personalDetailList from '@/views/shanghaicaijing/personalDetailList';
import newSearchNum from '@/views/xigongda/new-search-num';
import DecisionManagement from '@/views/decisionManagement';
import addDecisionColumn from '@/views/decisionManagement/addDecisionColumn';
import QRcode from '@/views/QRcode/QRcode';
import personInformation from '@/views/QRcode/personal-massage';
import newInfoCheck from '@/views/huanong/newInfoCheck';
import electronicDocumentTeacher from '@/views/zhicheng/electronicDocument/teacher'
import electronicDocumentStudent from '@/views/zhicheng/electronicDocument/student'
import electronicDocumentTeacherWithQrcode from '@/views/zhicheng/electronicDocument/teacherWithQrcode'
import electronicDocumentStudentWithQrcode from '@/views/zhicheng/electronicDocument/studentWithQrcode'
import electronicDocumentjingxiao from '@/views/zhicheng/electronicDocument/jingxiao'
import electronicDocumentceshi from '@/views/zhicheng/electronicDocument/ceshi'
import timedTask from '@/views/xigongda/timedTask'
import messageResend from '@/views/shangcai/messageResend'
import workDetail from '@/views/lianYunGang/workDetail'
import salaryDetail from '@/views/lianYunGang/salaryDetail'
import bookDetail from '@/views/lianYunGang/bookDetail'
import registerEmail from '@/views/xisu/registerEmail';
import bindEmail from '@/views/xisu/bindEmail';
import registerAccount from '@/views/xigongda/registerAccount';
import registerEmail2 from '@/views/xigongda/registerEmail';
import bindEmail2 from '@/views/xigongda/bindEmail';
import uploadSyetemService from '@/views/hunankeji/uploadSyetemService'
import systemServiceList from '@/views/hunankeji/systemServiceList'
import mailRegister from '@/views/hunankeji/mailRegister'

const ModulesRouter = {
	name: "Home",
	path: "/",
	component: Layout,
	redirect: "/uploadSyetemService",
	children: [{
		name: "SignIn",
		path: "signin",
		component: SignIn,
		meta: {
			title: "登录"
		}
	},
	{
		path: "userQuery",
		name: "userQuery",
		component: userQuery,
		meta: {
			title: "用户查询"
		}
	},
	{
		path: 'personalManage',
		name: 'personalManage',
		component: personalManage,
		meta: {
			title: '个人数据中心配置',

		}
	},
	{
		path: 'cmsColumn',
		name: 'cmsColumn',
		component: cmsColumn,
		meta: {
			title: 'cms栏目管理'
		},
		children: [{
			path: 'Column',
			name: 'Column',
			component: Column,
			meta: {
				title: '栏目管理'
			}
		},
		{
			path: 'AddColumn',
			name: 'AddColumn',
			component: AddColumn,
			meta: {
				title: '添加栏目'
			}
		}
		]
	},
	{
		path: 'electronicDocument/Teacher',
		name: 'electronicDocument/Teacher',
		component: electronicDocumentTeacher,
		meta: {
			title: '电子证件'
		}
	},
	{
		path: 'electronicDocument/Student',
		name: 'electronicDocument/Student',
		component: electronicDocumentStudent,
		meta: {
			title: '电子证件'
		}
	},
	{
		path: 'electronicDocument/teacherWithQrcode',
		name: 'electronicDocument/teacherWithQrcode',
		component: electronicDocumentTeacherWithQrcode,
		meta: {
			title: '电子证件'
		}
	},
	{
		path: 'electronicDocument/jingxiao',
		name: 'electronicDocument/jingxiao',
		component: electronicDocumentjingxiao,
		meta: {
			title: '通行证'
		}
	},
	{
		path: 'electronicDocument/studentWithQrcode',
		name: 'electronicDocument/studentWithQrcode',
		component: electronicDocumentStudentWithQrcode,
		meta: {
			title: '电子证件'
		}
	},
	{
		path: 'electronicDocument/ceshi',
		name: 'electronicDocument/ceshi',
		component: electronicDocumentceshi,
		meta: {
			title: '测试'
		}
	},
	{
		path: 'detailEdit',
		name: 'detailEdit',
		component: detailEdit,
		meta: {
			title: '一卡通编辑'
		}
	},
	{
		path: 'personalDetailList',
		name: 'personalDetailList',
		component: personalDetailList,
		meta: {
			title: '上海财经个人数据详情'
		}
	},
	{
		path: 'newSearchNum',
		name: 'newSearchNum',
		component: newSearchNum,
		meta: {
			title: '新生学号查询'
		}
	},
	{
		name: "DecisionManagement",
		path: "DecisionManagement",
		component: DecisionManagement,
		meta: {
			title: "决策中心菜单管理"
		}
	},
	{
		name: "addDecisionColumn",
		path: "addDecisionColumn",
		component: addDecisionColumn,
		meta: {
			title: "决策中心菜单管理"
		}
	},
	{
		name: "QRcode",
		path: "QRcode",
		component: QRcode,
		meta: {
			title: "二维码管理"
		}
	},
	{
		name: 'personInformation',
		path: 'personInformation',
		component: personInformation,
		meta: {
			title: '个人信息'
		}
	},
	{
		name: "personalMassage",
		path: "personalMassage",
		component: () => import("../../views/QRcode/personal2-massage"),
		meta: {
			title: "迎新码"
		}
	},
	{
		name: 'newInfoCheck',
		path: 'newInfoCheck',
		component: newInfoCheck,
		meta: {
			title: '新生信息校验'
		}
	},
	{
		name: 'timedTask',
		path: 'timedTask',
		component: timedTask,
		meta: {
			title: '定时任务'
		}
	},
	{
		name: 'messageResend',
		path: 'messageResend',
		component: messageResend,
		meta: {
			title: '消息重发'
		}
	},
	{
		name: 'workDetail',
		path: 'workDetail',
		component: workDetail,
		meta: {
			title: '一周工作详情'
		}
	},
	{
		name: 'salaryDetail',
		path: 'salaryDetail',
		component: salaryDetail,
		meta: {
			title: '工资查询详情'
		}
	},
	{
		name: 'bookDetail',
		path: 'bookDetail',
		component: bookDetail,
		meta: {
			title: '图书查询详情'
		}
	},
	{
		name: 'registerEmail',
		path: 'registerEmail',
		component: registerEmail,
		meta: {
			title: '注册邮箱'
		}
	},
	{
		name: 'bindEmail',
		path: 'bindEmail',
		component: bindEmail,
		meta: {
			title: '绑定邮箱'
		}
	},
	{
		name: 'registerAccount',
		path: 'registerAccount',
		component: registerAccount,
		meta: {
			title: '创建上网账号'
		}
	},
	{
		name: 'registerEmail2',
		path: 'registerEmail2',
		component: registerEmail2,
		meta: {
			title: '注册邮箱'
		}
	},
	{
		name: 'bindEmail2',
		path: 'bindEmail2',
		component: bindEmail2,
		meta: {
			title: '绑定邮箱'
		}
	},
	{
		name: 'uploadSyetemService',
		path: 'uploadSyetemService',
		component: uploadSyetemService,
		meta: {
			title: '上传系统服务'
		}
	},
	{
		name: 'systemServiceList',
		path: 'systemServiceList',
		component: systemServiceList,
		meta: {
			title: '系统服务列表'
		}
	},
	{
		name: 'mailRegister',
		path: 'mailRegister',
		component: mailRegister,
		meta: {
			title: '邮箱注册'
		}
	}
	]
};

export default ModulesRouter;
